import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const aboutPopupBackdropClass = css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const aboutPopupContainerClass = css`
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;

    @media (max-width: 768px) {
        width: 95%;
        max-height: 90vh;
    }
`;

export const userProfileWrpClass = css`
    padding: 2rem;

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`;

export const popupHeaderClass = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #eee;
    padding-bottom: 1rem;

    h2 {
        color: #333;
        margin: 0;
        font-size: 1.5rem;
        font-weight: 600;

        @media (max-width: 768px) {
            font-size: 1.25rem;
        }
    }
`;

export const closeButtonClass = css`
    background: none;
    border: none;
    font-size: 2rem;
    color: #666;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s;

    &:hover {
        background: #f0f0f0;
        color: #333;
    }
`;

export const loadingStateClass = css`
    text-align: center;
    padding: 2rem;
    color: #666;

    p {
        margin: 0;
        font-size: 0.9rem;
    }
`;

export const spinnerClass = css`
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #0066cc;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 1rem;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const errorStateClass = css`
    text-align: center;
    padding: 2rem;
    color: #d32f2f;

    h4 {
        color: #d32f2f;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .error-icon {
            font-style: normal;
        }
    }

    p {
        color: #666;
        margin-bottom: 1.5rem;
    }
`;

export const retryButtonClass = css`
    background: #0066cc;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.2s;

    &:hover {
        background: #0052a3;
    }
`;

export const userInfoClass = css`
    h4 {
        color: #333;
        margin: 1rem 0 0.5rem 0;
        font-size: 1rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        i {
            font-style: normal;
            width: 16px;
            text-align: center;
        }

        &:first-child {
            margin-top: 0;
        }

        @media (max-width: 768px) {
            font-size: 0.9rem;
        }
    }
`;

export const rolesSectionClass = css`
    margin-top: 1.5rem;
`;

export const rolesListClass = css`
    margin-top: 0.5rem;
    padding-left: 1.5rem;

    @media (max-width: 768px) {
        padding-left: 1rem;
    }
`;

export const roleItemClass = css`
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #0066cc;

    @media (max-width: 768px) {
        padding: 0.4rem;
    }
`;

export const roleNameClass = css`
    font-weight: 600;
    color: #333;
    display: block;

    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
`;

export const roleDescriptionClass = css`
    font-size: 0.85rem;
    color: #666;
    margin-top: 0.25rem;
    display: block;

    @media (max-width: 768px) {
        font-size: 0.8rem;
    }
`;

export const systemInfoClass = css`
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #eee;

    p {
        margin: 0.25rem 0;
        font-size: 0.9rem;
        color: #666;
        padding-left: 1.5rem;

        @media (max-width: 768px) {
            font-size: 0.85rem;
            padding-left: 1rem;
        }
    }
`;

export const popupActionsClass = css`
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid #eee;
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
    
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0.5rem;
    }
`;

export const CloseBtn = styled.button`
    background: #666;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 600;
    transition: background-color 0.2s;

    &:hover {
        background: #555;
    }
`;

// Derive from global TextButton with custom padding and sizing for dialog context
import { TextButton } from '../../styles/button.style';

export const SignOutBtn = styled(TextButton)`
    height: auto;
    padding: 0.6rem 1.5rem;
    font-size: 0.95rem;
    font-weight: 500;
`;